import axios from 'axios';

export class YouTubeService {
    static apiKey = 'AIzaSyD8wiF7iXUo5zmvc-jQP3cXu5MWsvToj70'; 
    static playlistId = 'PL2zbwqdfhrcBlokcnEJrtmXT7Ea_HJw8b'; 
    static channelId = 'UCp6JgACkLj9JIYRadmsQKMA';

    static async getPlaylistItems() {
        const url = `https://www.googleapis.com/youtube/v3/playlistItems`;
        const params = {
            part: 'contentDetails, snippet',
            maxResults: 50,
            playlistId: this.playlistId,
            key: this.apiKey
        };

        try {
            const response = await axios.get(url, {params});
            return response.data.items;
        } catch (error) {
            console.error('Error fetching data from YouTube API', error);
            throw error;
        }
    }


    static async getPlaylistSearch(search = '') {
        const url = `https://www.googleapis.com/youtube/v3/search`;
        const params = {
            key: this.apiKey,
            part: 'snippet',
            maxResults: 50,
            q: search,
            type: 'video',
            channelId: this.channelId,
        };

        try {
            const response = await axios.get(url, {params});
            return response.data.items;
        } catch (error) {
            console.error('Error fetching data from YouTube API', error);
            throw error;
        }
    }
}
